export default interface AccountInterface {
    id: string;
    userId: string;
    accountNumber: string;
    fundId: string;
    fundName:string;
    investorName: string;
    entryDateTime: string;
    updateDateTime: string;
    email: string;
  returnedInWallet: string;
    fund: any;
    user: any;
  }
  
  const accountInitialValue: AccountInterface = {
    id: String(),
    userId: String(),
    accountNumber: String(),
    fundId:String(),
    fundName:String(),
    investorName: String(),
    entryDateTime:String(),
    updateDateTime: String(),
    email: String(),
    returnedInWallet: String(),
    user: {},
    fund: {}
  };
  
  export { accountInitialValue };
  